module.exports = __webpack_public_path__ + "4ef30196dccf8ff6c8e319cf8f386eb3.pdf";